export const SITE_CONFIG = {
  name: "Oyanishikigoi",
  tagline: "Premium Nishikigoi & Aquarium Supplies",
  description: "Sri Lanka's premier destination for high-quality Japanese Koi fish, aquarium supplies, and expert pond services.",
  contact: {
    phone: "+94 77 123 4567",
    email: "info@oyanishikigoi.com",
    whatsapp: "+94771234567",
  },
  locations: [
    {
      name: "Main Showroom",
      address: "123 Koi Lane, Colombo 05",
      city: "Colombo",
    },
    {
      name: "Farm & Breeding Center",
      address: "456 Pond Road, Negombo",
      city: "Negombo",
    },
  ],
  socialLinks: {
    facebook: "https://facebook.com/oyanishikigoi",
    instagram: "https://instagram.com/oyanishikigoi",
    youtube: "https://youtube.com/@oyanishikigoi",
  },
  currency: "LKR",
  currencySymbol: "Rs.",
};

export const SERVICE_TYPES = [
  { value: "pond_maintenance", label: "Pond Maintenance" },
  { value: "tank_setup", label: "Tank Setup & Installation" },
  { value: "fish_health_check", label: "Fish Health Check" },
  { value: "consultation", label: "Consultation" },
  { value: "other", label: "Other" },
] as const;

export const ORDER_STATUSES = [
  { value: "pending", label: "Pending", color: "bg-yellow-500" },
  { value: "payment_verified", label: "Payment Verified", color: "bg-blue-500" },
  { value: "confirmed", label: "Confirmed", color: "bg-green-500" },
  { value: "processing", label: "Processing", color: "bg-purple-500" },
  { value: "shipped", label: "Shipped", color: "bg-indigo-500" },
  { value: "delivered", label: "Delivered", color: "bg-emerald-500" },
  { value: "cancelled", label: "Cancelled", color: "bg-red-500" },
] as const;

export const PAYMENT_METHODS = [
  { value: "cod", label: "Cash on Delivery" },
  { value: "bank_transfer", label: "Bank Transfer" },
] as const;

export const KOI_VARIETIES = [
  "Kohaku",
  "Taisho Sanke",
  "Showa Sanshoku",
  "Tancho",
  "Shiro Utsuri",
  "Hi Utsuri",
  "Ki Utsuri",
  "Asagi",
  "Shusui",
  "Bekko",
  "Utsurimono",
  "Goshiki",
  "Koromo",
  "Kawarimono",
  "Hikari Muji",
  "Hikari Moyo",
  "Hikari Utsuri",
  "Kinginrin",
  "Doitsu",
  "Other",
] as const;
